//GENERAL
import Tooltip from "@mui/material/Tooltip";
import React, { useEffect, useRef, useState } from "react";
import { FormProvider, useForm, useFormContext, useWatch } from "react-hook-form";
//COMPONENTS
import { CalendarForm } from "../../../components/ComponentesFormularios/CalendarForm";
import InputForm from "../../../components/ComponentesFormularios/InputForm";
import Emitter from "src/EventEmitter/EventEmitter";
import SelectFormVirtualize from "../../../components/ComponentesFormularios/SelectFormVirtualize";
import NestedSelectVirtualizeForm from "../../../components/ComponentesFormularios/NestedSelectVirtualizeForm";
import AgGridTable from "src/components/AgGridTable";
import AccionesTable from "src/components/AccionesTable";
//REDUX 
import { useDispatch, useSelector } from "react-redux";
//SERVICES
import { modalCRUDService } from "../../../services/modalCRUDService";
import { alertQuestionService } from "src/services/alertQuestionService";
import { crearActivosService } from "src/services/apiCrearActivos";
//UTILS
import { isObject } from "src/util/is";
//CONSTANTS
import { GlobalConstants } from "../../../data/GlobalConstants";
import { ConstantEventEmitter } from "src/data/ConstantEventEmitter";
import { classResponsiveFormWidthHeader, ERRORFIELDREQUIRED } from "../../../data/ConstantForm";
//STYLES
import { Colors } from "../../../assets/colors/Colors";

const columnDef = [
    {headerName: 'Descripción', field: "nmAccesorio", resizable: true, sortable: false, filter: false, editable: true },
    {headerName: 'Cantidad', field: "nbCantidad", resizable: true, sortable: true, editable: true, cellRendererSelector: () => ({
        component: 'validNumber',
    })},
    {headerName: 'Acciones',field: "acciones", cellRenderer: 'accionesComponent', width: '100%'},
]

const AccionesAccesorios = ({ params }) => {
    return (
        <AccionesTable accionesBasicas={false} editAction={false} deleteAccion={true} params={params} />
    )
}

const Accesorios = ({isEditing, tableRefAcc}) => {

    const { setValue, control, formState: { errors } } = useFormContext();
    const dispatch = useDispatch();

    const nombre = useWatch({
        name: "nombre",
        control
    })

    const cantidad = useWatch({
        name: "cantidad",
        control
    })

    const addToTable = () => {

        if (nombre == '' || nombre == undefined) {

            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: 'Agregue una descripción y una cantidad' } });
            return
        }

        let cont = 1,
            result = []

        tableRefAcc.current.api.forEachNodeAfterFilter( node => {
            node.data['id'] = cont
            result.push(node.data)
            cont ++
        })

        result.push({
            id: cont,
            nmAccesorio: nombre,
            nbCantidad: cantidad
        });

        tableRefAcc.current.api.setRowData(result)

        setValue('nombre','')
        setValue('cantidad',0)
    }

    const cellValidNumber = (params) => {
        if(params.data.nbCantidad == undefined || params.data.nbCantidad < 1) return <span>1</span>
        else return <span>{params.value}</span>
    }

    return (
        <>
            <div className="d-flex align-items-center">
                <InputForm inputProps={{ control }} identificador="nombre" label="Descripción" readOnly={!isEditing}
                        placeholder="" required={false} type="text" className={`${classResponsiveFormWidthHeader}`}
                        customError={errors.nombre ? ERRORFIELDREQUIRED : null} />

                <InputForm inputProps={{ control }} identificador="cantidad" label="Cantidad" readOnly={!isEditing}
                        placeholder="" required={false} type="number" className={`${classResponsiveFormWidthHeader}`}
                        customError={errors.cantidad ? ERRORFIELDREQUIRED : null} />

                <Tooltip title="Agregar" aria-label="Agregar">
                    <a onClick={() => addToTable() } className="icon-container-actions d-flex">
                      <div style={{backgroundColor: Colors.COLOR_BLUE_THEME}}/>
                      <i style={{color: Colors.COLOR_BLUE_THEME}} className="fas fa-plus fa-2x"/>
                    </a>
                </Tooltip>
            </div>

            <AgGridTable
                referencia={tableRefAcc}
                columnDef={columnDef}
                dataList={[]}
                height='30vh'
                acciones={AccionesAccesorios}
                rowSelection="multiple"
                frameworkComponents={{
                    validNumber: cellValidNumber
                }}/>
            </>
    )
}


const DatosFactura = ({isEditing}) => {

    const { control, formState: { errors } } = useFormContext();

    const [state, setState] = useState({required: false})

    const factura = useWatch({
        name: "factura",
        control
    })

    useEffect(() => {
        
        if(factura?.length >= 1) {
            setState({...state, required: true})
        }
        else {
            setState({...state, required: false})
        }

    }, [factura])

    return (
        <>
            <InputForm inputProps={{ control }} identificador="factura" label="Factura Compra" readOnly={!isEditing}
                placeholder="" required={false} type="text" className={`${classResponsiveFormWidthHeader}`}
                customError={errors.factura ? ERRORFIELDREQUIRED : null} />

            <InputForm inputProps={{ control }} identificador="dtFactura" label="Fecha Factura" readOnly={!isEditing}
                placeholder="AAAA-MM-DD" required={state.required} type="text" className={`${classResponsiveFormWidthHeader}`}
                customError={errors.dtFactura ? 'Formato fecha inválido' : null} rules={{pattern: /^\d{4}-\d{2}-\d{2}$/}} />

            <InputForm inputProps={{ control }} identificador="valorFactura" label="Valor Factura" readOnly={!isEditing}
                placeholder="" required={state.required} type="number" className={`${classResponsiveFormWidthHeader}`}
                customError={errors.valorFactura ? 'El valor no puede ser cero' : null} rules={{  min: state.required ? 1 : 0 }} />

            <CalendarForm inputProps={{ control }} disabled={true} identificador="dtCreacion" label="Fecha Creación"
                required={true} className={`${classResponsiveFormWidthHeader}`} customError={errors.dtCreacion ? ERRORFIELDREQUIRED : null} />
        </>
    )
}


const DatosBasicos = ({ isEditing, isAddMode, properties, stateSelects, tableRefAcc }) => {

    const { data } = properties
    console.log('data', data)
    const [dataEstadoDispo, setDataEstadoDispo] = useState([])
    const isMount = useRef(true);
    const generalService = useSelector(state => state.generalServices);
    const dispatch = useDispatch();
    const { control, formState: { errors }, setValue } = useFormContext();

    /** use watch **/

    const referencia = useWatch({
        name: "referencia",
        control
    })

    const ubicacion = useWatch({
        name: "ubicacion",
        control
    })

    const estadoDisponibilidad = useWatch({
        name: "estadoDisponible",
        control
    })

    /** use effect**/
    useEffect(() => {
        return () => {
            isMount.current = false;

            Emitter.off(ConstantEventEmitter.eventDeleteTable);
        }
    }, [])

    useEffect(() => {

        Emitter.on(ConstantEventEmitter.eventDeleteTable, ({ params, type }) => handleDeleteRowTable({ params, type }));
    }, [])

    useEffect(() => {
        
        getAccesorios()
    }, [referencia])

    useEffect(() => {
        
        if(isObject(ubicacion)){
            setDataEstadoDispo(JSON.parse(ubicacion['disponibilidades']))
        }else{
            if(!isAddMode){
                setValue('ubicacion', generalService?.arrUbicaciones[ubicacion-1])
                setValue('estadoDisponible', data.estadoDisponible)
            }
        }
    }, [ubicacion])

    useEffect(() => {
        crearActivosService.getEstadoActivos({
            ubicacion: isObject(ubicacion) ? ubicacion.id : ubicacion,
            estado:  isObject(estadoDisponibilidad) ? estadoDisponibilidad.id : estadoDisponibilidad
        }).then(
            response => {
                const { status, data: datos } = response

                if(status){

                    dispatch({
                        type: 'setStateGeneralServices', generalServices: {
                            ...generalService,
                            arrEstadoActivos: datos
                        }
                    });

                    if(!isAddMode){
                        setValue('estadoActivo', data.estadoActivo)
                    }
                }
            }
        )
    }, [estadoDisponibilidad])

    /** Functions **/
    const getAccesorios = async () => {

        let jsReferencia = []
        let jsAccesorios =  data?.jsActivo ? JSON.parse(data.jsActivo) : {}
        let setData = []
        let res = await crearActivosService.getAccesoriosByReferencia(isObject(referencia) ? referencia?.id : referencia)


        if (Object.keys(res.data).length > 0) {

            jsReferencia = JSON.parse(res.data?.jsReferencia)
    
            if (jsReferencia?.arrAccesorios != undefined || jsReferencia?.arrAccesorios != null) {
                setData = jsReferencia?.arrAccesorios
                if (jsAccesorios.length > 0) {
                    setData = jsAccesorios?.arrAccesorios
                }
    
                tableRefAcc.current.api.setRowData(setData)
            }
            else {
                tableRefAcc.current.api.setRowData(jsAccesorios?.arrAccesorios)
            }
        }
    }

    const handleDeleteRowTable = ({params, type}) => {
        const rowData = params.node.data;
        params.api.applyTransaction({
            remove: [rowData]
        })

        alertQuestionService.clear();
    }

    return (
        <div className="container mx-0 px-0 w-100 mw-100">

            <div className="mt-3 p-2 bg-white" style={{border: '1px solid #C6C6C6', borderRadius: 5}}>

                <h4>Referencia</h4>

                <hr className="m-0 p-0"/>

                <div className="row mx-1 align-items-center justify-content-start mt-2">
                    
                    <NestedSelectVirtualizeForm disabled={!isEditing} showId={false} keyIdentificador="tipoReferencia" label="Tipo de Activo" required={true}
                        className={classResponsiveFormWidthHeader} options={stateSelects?.arrTipoActivos}
                        customError={errors.tipoReferencia ? ERRORFIELDREQUIRED : null}
                        keyFatherValue="propietario" />

                    <NestedSelectVirtualizeForm disabled={!isEditing} keyIdentificador="referencia" label="Referencia" required={true}
                        className={classResponsiveFormWidthHeader} options={stateSelects?.arrReferencias}
                        customError={errors.referencia ? ERRORFIELDREQUIRED : null}
                        keyFatherValue="tipoReferencia" />

                    <InputForm inputProps={{ control }} identificador="placa" label="Placa" readOnly={!isEditing}
                        placeholder="" required={false} type="text" className={`${classResponsiveFormWidthHeader}`}
                        customError={errors.placa ? ERRORFIELDREQUIRED : null} />

                    <InputForm inputProps={{ control }} identificador="serial" label="Serial" readOnly={!isEditing}
                        placeholder="" required={false} type="text" className={`${classResponsiveFormWidthHeader}`}
                        customError={errors.serial ? ERRORFIELDREQUIRED : null} />

                </div>

                <div className="row mx-1 align-items-center justify-content-start mt-2">

                    <SelectFormVirtualize inputProps={{ control }} disabled={!isEditing} identificador="ubicacion" label="Ubicación"
                        options={stateSelects?.arrUbicaciones} required={true} className={`${classResponsiveFormWidthHeader}`} readOnly={false}
                        customError={errors.ubicacion ? ERRORFIELDREQUIRED : null} />

                    <SelectFormVirtualize inputProps={{ control }} disabled={!isEditing} identificador="estadoDisponible" label="Estado Disponibilidad"
                        options={dataEstadoDispo} required={true} className={`${classResponsiveFormWidthHeader}`} readOnly={false}
                        customError={errors.estadoDisponible ? ERRORFIELDREQUIRED : null} />

                    <SelectFormVirtualize inputProps={{ control }} disabled={!isEditing} identificador="estadoActivo" label="Estado Activos"
                        options={stateSelects?.arrEstadoActivos} required={true} className={`${classResponsiveFormWidthHeader}`} readOnly={false}
                        customError={errors.estadoActivo ? ERRORFIELDREQUIRED : null} />

                </div>
                <div className="row mx-1 align-items-center justify-content-start mt-2">

                    <DatosFactura isEditing={isEditing} />
                </div>

            </div>

            <div className="mt-3 p-2 bg-white" style={{border: '1px solid #C6C6C6', borderRadius: 5}}>

                <h4>Accesorios</h4>

                <hr className="mb-3 mt-0 p-0"/>

                <Accesorios isEditing={isEditing} tableRefAcc={tableRefAcc} />

            </div>

        </div>
    )
}

const FormCrearActivoCRUD = ({ isEditing, properties, isAddMode }) => {

    const { data, tableRef } = properties;
    const tableRefAcc = useRef(null);
    const dispatch = useDispatch();
    const generalServicesState = useSelector(state => state.generalServices)
    const authState = useSelector(state => state.auth)
    const { idUsuario } = authState;
    const methods = useForm({
        defaultValues: {
            ...data,
            dtCreacion: data?.dtCreacion,
            dtFactura: data?.dtFactura,
        }
    });
    const { handleSubmit, formState: { errors }, control } = methods;

    const onSuccessSubmit = async data => {

        data.idUsrAuditoria = idUsuario;
        data.ac = isAddMode && isEditing ? 'C' : isEditing ? 'A' : 'LOCK';

        let jsAccesorios = []

        tableRefAcc.current.api.forEachNodeAfterFilter( nodo => {
            jsAccesorios.push({
                nmAccesorio: nodo.data.nmAccesorio,
                nbCantidad: nodo.data.nbCantidad
            })
        })

        data.jsAccesorios = JSON.stringify(jsAccesorios)

        try {
            let response = await crearActivosService.crudCrearActivos(data)

            const { status, data: datos } = response;

            if (status) {
                if (datos?.idmsg === 200) {
                    modalCRUDService.clear();

                    let res = await crearActivosService.getAllCrearActivos()

                    const { status, data } = res;
                    
                    if (status) {
                        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess, message: datos?.txmsg } });
                        tableRef.current.api.setRowData(data.rows)
                    }
                } else {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: datos?.txmsg } });
                }
            }    
        } catch (error) {
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: error.toString() } });
        }
    }

    const onErrorSubmit = errors => {
        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: 'Error en el formulario' } });
    }

    return (
        <FormProvider {...methods} >
                <header className="px-4 d-flex align-items-center mw-100 mt-2 justify-content-between">

                    <div className="row w-50">

                        <SelectFormVirtualize inputProps={{ control }} showId={false} disabled={!isEditing} identificador="propietario" label="Propietario"
                            options={generalServicesState?.arrPropietarios} required={true} className={`px-2 w-50`} readOnly={false}
                            customError={errors.propietario ? ERRORFIELDREQUIRED : null} />

                        <SelectFormVirtualize inputProps={{ control }} disabled={!isEditing} identificador="agente" label="Agente Comercial"
                            options={generalServicesState?.arrAgentes} required={false} className={`px-2 w-50`} readOnly={false}
                            customError={errors.agente ? ERRORFIELDREQUIRED : null} />
                    </div>

                    <div className="d-flex justify-content-end align-items-center">
                        {isEditing &&
                            <Tooltip title="Guardar" aria-label="guardar">
                                <a onClick={handleSubmit(onSuccessSubmit, onErrorSubmit)}
                                    className="icon-container-actions d-flex">
                                    <div style={{ backgroundColor: Colors.COLOR_GREEN_DARK }} />
                                    <i style={{ color: Colors.COLOR_GREEN_DARK }} className="fas fa-check fa-2x" />
                                </a>
                            </Tooltip>
                        }
                        <Tooltip title="Cancelar" aria-label="cancelar">
                            <a onClick={() => { modalCRUDService.clear() }} className="icon-container-actions d-flex">
                                <div style={{ backgroundColor: Colors.RED_SWITCH_INACTIVE }} />
                                <i style={{ color: Colors.RED_SWITCH_INACTIVE }} className="fas fa-times fa-2x" />
                            </a>
                        </Tooltip>
                    </div>

                </header>
                <DatosBasicos isEditing={isEditing} properties={properties} stateSelects={generalServicesState} isAddMode={isAddMode} tableRefAcc={tableRefAcc} />
        </FormProvider>
    )
}

export default FormCrearActivoCRUD;